import React from 'react';
import { Card, Typography, Button, Avatar, Tag, Tooltip } from 'antd';
import { ArrowLeftOutlined, PhoneOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const avatarColors = ['#1677ff', '#52c41a', '#722ed1', '#fa8c16', '#13c2c2', '#eb2f96'];

const FollowUpsDuePage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const list = location.state?.list || [];

    return (
        <Card bordered={false} bodyStyle={{ padding: 0 }} style={{ minHeight: '100vh', background: '#fff', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{
                padding: '16px 24px', borderBottom: '1px solid #f0f0f0', display: 'flex',
                justifyContent: 'space-between', alignItems: 'center', background: '#fff',
                borderTopLeftRadius: 12, borderTopRightRadius: 12,
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />
                    <div>
                        <Typography.Title level={4} style={{ margin: 0, color: 'rgba(14, 93, 146, 0.95)' }}>Follow-ups Due</Typography.Title>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>Overdue and scheduled for today</Typography.Text>
                    </div>
                </div>
                <span style={{
                    fontSize: 13, fontWeight: 600, color: '#fa8c16', background: '#fff7e6',
                    border: '1px solid #ffd591', borderRadius: 16, padding: '4px 14px',
                }}>

                    {list.length} due

                </span>
            </div>

            <div style={{ padding: 20 }}>
                {list.length === 0 ? (
                    <Card style={{ borderRadius: 10, border: '1px solid #f0f0f0', textAlign: 'center', padding: '40px 0' }}>
                        <ClockCircleOutlined style={{ fontSize: 32, color: '#bbb' }} />
                        <div style={{ marginTop: 10 }}>
                            <Typography.Text type="secondary">No follow-ups found</Typography.Text>
                        </div>
                    </Card>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {list.map((f, i) => {
                            const color = avatarColors[i % avatarColors.length];
                            return (
                                <Card
                                    key={f.eq_id || i}
                                    style={{
                                        borderRadius: 10, border: '1px solid #f0f0f0',
                                        borderLeft: `4px solid ${f.isOverdue ? '#ff4d4f' : '#faad14'}`,
                                    }}
                                    bodyStyle={{ padding: '12px 16px' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                        <Avatar size={40} style={{ background: color, fontWeight: 700, flexShrink: 0 }}>
                                            {(f.company || '?').charAt(0).toUpperCase()}
                                        </Avatar>

                                        <div style={{ flex: 2, minWidth: 0 }}>
                                            <div style={{ fontWeight: 600, fontSize: 14, color: '#1f1f1f' }}>{f.company}</div>
                                            <div style={{ fontSize: 12, color: '#999', display: 'flex', alignItems: 'center', gap: 4 }}>
                                                <PhoneOutlined style={{ fontSize: 11 }} /> {f.mobile || '-'}
                                            </div>
                                        </div>

                                        <div style={{ flex: 1.4 }}>
                                            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>ENQUIRY</div>
                                            <div style={{ fontSize: 13, color: '#1677ff', fontWeight: 600 }}>{f.eq_id}</div>
                                        </div>

                                        <div style={{ flex: 2 }}>
                                            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>SERVICE</div>
                                            <div style={{ fontSize: 13, color: '#333' }}>{f.service}</div>
                                        </div>

                                        <div style={{ flex: 1.4, textAlign: 'center' }}>
                                            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>ASSIGNED</div>
                                            <div style={{ fontSize: 13, color: '#333', fontWeight: 500 }}>{f.assigned}</div>
                                        </div>

                                        <div style={{ flex: 1.4, textAlign: 'center' }}>
                                            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>DUE DATE</div>
                                            <Tooltip
                                                title={
                                                    f.isOverdue
                                                        ? `${f.daysOverdue} day${f.daysOverdue === 1 ? '' : 's'} overdue`
                                                        : 'Due today'
                                                }
                                            >
                                                <Tag
                                                    color={f.isOverdue ? 'error' : 'warning'}
                                                    style={{ margin: 0, fontWeight: 600, cursor: 'default' }}
                                                >
                                                    {f.time}
                                                </Tag>
                                            </Tooltip>
                                        </div>

                                        <div style={{ flexShrink: 0 }}>
                                            <Button
                                                style={{ background: 'rgba(14, 93, 146, 0.95)', color: '#fff', borderColor: 'rgba(14, 93, 146, 0.95)' }}
                                                onClick={() => navigate(`/enquiry/edit/${f.eq_id}`)}
                                            >
                                                Open
                                            </Button>
                                        </div>
                                    </div>
                                </Card>
                            );
                        })}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default FollowUpsDuePage;